import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, IDR, imgUrl } from "@/lib/api";
import { toast } from "sonner";

export default function AdminProducts() {
  const [products, setProducts] = useState([]);
  const load = () => api.get("/products", { params: { admin_view: true, limit: 500 } }).then((r) => setProducts(r.data));
  useEffect(() => { load(); }, []);
  const dup = async (id) => {
    const code = window.prompt("Kode Artikel baru (contoh: TS-002):");
    if (!code) return;
    try { await api.post(`/products/${id}/duplicate`, { article_code: code }); toast.success("Duplikat berhasil"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); }
  };
  const archive = async (id) => {
    if (!window.confirm("Arsipkan produk ini?")) return;
    await api.delete(`/products/${id}`); toast.success("Diarsipkan"); load();
  };
  return (
    <div>
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <h1 className="display text-4xl md:text-6xl">PRODUCTS</h1>
        <div className="flex gap-2">
          <Link to="/admin/import" data-testid="import-csv-link" className="border border-white px-6 py-3 text-xs tracking-widest">IMPORT CSV</Link>
          <Link to="/admin/products/new" data-testid="new-product-btn" className="bg-white text-black px-6 py-3 text-xs tracking-widest">+ NEW PRODUCT</Link>
        </div>
      </div>
      <div className="border border-[color:var(--border)] overflow-x-auto">
        <table className="w-full text-sm min-w-[900px]">
          <thead className="text-[10px] tracking-widest text-neutral-500">
            <tr className="border-b border-[color:var(--border)]">
              <th className="p-3 text-left">IMG</th><th className="p-3 text-left">CODE</th><th className="p-3 text-left">NAME</th>
              <th className="p-3 text-left">CATEGORY</th><th className="p-3 text-left">PRICE</th>
              <th className="p-3 text-left">STATUS</th><th className="p-3 text-left">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p.id} data-testid={`row-${p.article_code}`} className="border-b border-[color:var(--border)]">
                <td className="p-3"><img src={imgUrl(p.front_image) || "https://placehold.co/60x80/000/fff?text=—"} alt="" className="w-12 h-16 object-cover" /></td>
                <td className="p-3 mono">{p.article_code}</td>
                <td className="p-3">{p.name}</td>
                <td className="p-3">{p.category_name}</td>
                <td className="p-3 tabular-nums">{IDR(p.price)}</td>
                <td className="p-3"><span className="status-badge">{p.status}</span></td>
                <td className="p-3 space-x-2 whitespace-nowrap">
                  <Link to={`/admin/products/${p.id}`} className="underline">Edit</Link>
                  <button onClick={() => dup(p.id)} className="underline">Duplicate</button>
                  <button onClick={() => archive(p.id)} className="underline text-[color:var(--accent)]">Archive</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
